<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-6 col-6">
                    <h2>Accounts</h2>
                    </div>
                    <div class="col-lg-6 col-6 text-right bid">
                    <button type="button" @click="exportAccount()" class="btn btn-warning rounded ml-1">
                      <i v-if="!exporting" class="fas fa-download"></i> 
                      <i v-if="exporting" class="fa fa-spinner fa-spin"></i>
                      <span v-if="!exporting">EXPORT</span>
                      <span v-if="exporting">EXPORTING...</span>
                    </button>
                    <button type="button" @click="updateAccounts()" class="btn btn-success rounded ml-1">
                      <i class="fas fa-check"></i> 
                      <span>UPDATE ACCOUNTS</span>
                    </button>
                    
                    <form @submit.prevent="" class="form-inline d-flex justify-content-center md-form form-sm mt-0">
                        <i @click="searchAccount()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                        <input v-on:keyup.enter="searchAccount" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm ml-3 w-75" type="text" placeholder="Search" aria-label="Search">
                        <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                        </form>              
                    </div>
                </div>
                
            </div>
            </div>
        </div>
        <div class="container-fluid mt--6 filter-show">
          <div class="card w-100 p-2 mb-2  d-inline-block">
            <div class="d-flex justify-content-between">
              <h5 class="mt-2">Filters</h5>
              <span class="btn btn-outline-secondary" @click="showFilters = !showFilters">
                <i class="fa" v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']" ></i> {{showFilters ? 'Hide' : 'Show'}} Filters
              </span>
            </div>
            <div class="row" v-if="showFilters">
              <div class="col-lg-12">
                <form class="row"  @submit.prevent=""    @submit="getAccountsList()" >
                  <div class="col-md-4 col-lg-3">
                    <label for="filter">Include margin account?</label>
                    <select v-model="isMarginAcount" class="form-control" style="height: 40px;" >
                      <option value="">SELECT</option>
                      <option value="true">YES</option>
                      <option value="false">NO</option>
                    </select> 
                  </div>
                  <div class="col-md-4 col-lg-3">
                    <label for="filter">Active account?</label >
                    <select v-model="isExport" class="form-control" style="height: 40px;">
                      <option value="">SELECT</option>
                      <option value="true">YES</option>
                      <option value="false">NO</option>
                    </select> 
                  </div>
                  <div class="col-md-4 col-lg-3">
                    <label for="filter">Primary Rep</label>
                    <multiselect 
                        v-model="primaryRep" 
                        placeholder="Select" 
                        :options="representativeData" 
                        :multiple="false" 
                        label="firstName" 
                        track-by="id" >
                        </multiselect>
                  </div>
                  <div class="col-md-4 col-lg-3">
                    <label for="filter">Secondary Rep</label>
                    <multiselect 
                        v-model="secondaryRep" 
                        placeholder="Select" 
                        :options="representativeData" 
                        :multiple="false" 
                        label="firstName" 
                        track-by="id" >
                        </multiselect>
                  </div>
                  <div class="col-md-4 col-lg-3">
                    <label for="filter">Note</label>
                    <input id="filter" v-model="noteFilter" type="text" class="form-control" style="height: 40px;" >
                    
                  </div>
                  <div class="col-md-4 col-lg-3">
                    <button @click="clearFilter()" type="button" class="btn btn-secondary rounded mt-4">Clear</button>
                    <button @click="getAccountsList()" type="button" class="btn btn-success rounded mt-4">Filter</button>
                  </div>
                </form>
                
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid dashboard" >
            <div class="row">
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl">
                            <thead class="thead-light psticky">
                            <tr>
                                <th 
                                  scope="col" 
                                  class="sort"
                                  >Select</th>
                                <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'account'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'account'  ? 'sort-desc' : '']"  
                                    @click="sort('account')" >Account</th>
                               <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'isMargin'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'isMargin'  ? 'sort-desc' : '']"  
                                    @click="sort('isMargin')" >Is Margin</th>
                                <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'fbsiShortName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'fbsiShortName'  ? 'sort-desc' : '']"  
                                    @click="sort('fbsiShortName')" >fbsi ShortName</th>  
                                <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'noteLastEditedDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'noteLastEditedDate'  ? 'sort-desc' : '']"  
                                    @click="sort('noteLastEditedDate')" >Note<br><span class="text-info">Last updated on</span></th> 
                                <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'pmp'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'pmp'  ? 'sort-desc' : '']"  
                                    @click="sort('pmp')" >Pmp</th>
                                <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'export'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'export'  ? 'sort-desc' : '']"  
                                    @click="sort('export')" >Active Account</th>
                                <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'maturity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'maturity'  ? 'sort-desc' : '']"  
                                    @click="sort('maturity')" >Maturity</th>
                                <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'spread'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'spread'  ? 'sort-desc' : '']"  
                                    @click="sort('spread')" >Spread</th>
                                <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'contact'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'contact'  ? 'sort-desc' : '']"  
                                    @click="sort('contact')" >Contact</th>
                                 <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'eod'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'eod'  ? 'sort-desc' : '']"  
                                    @click="sort('eod')" >EOD</th>
                                    <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'primaryRepName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'primaryRepName'  ? 'sort-desc' : '']"  
                                    @click="sort('primaryRepName')" >Primary Rep</th>
                                    <th 
                                    scope="col" 
                                    class="sort"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'secondaryRepName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'secondaryRepName'  ? 'sort-desc' : '']"  
                                    @click="sort('secondaryRepName')" >Secondary Rep</th>                                 
                                <th 
                                    scope="col" 
                                    class="text-center">Action</th>
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="totalRows == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="data in accountListData" :key="data.id">
                                <td>
                                  <input v-model="data.isSelect" type="checkbox" class="form-check-input" />
                                </td>
                                <td>{{data.account}}</td>
                                <td>{{data.isMargin}}</td>
                                <td v-if="data.account != 'PROSPECT'">{{data.fbsiShortName}}</td>
                                <td v-if="data.account == 'PROSPECT'">{{data.customerLastName}}</td>
                                <!-- <td>{{data.fbsiShortName ? data.fbsiShortName : 'N/A' }}</td> -->
                                <td data-toggle="tooltip" data-placement="left"  v-bind:title='data.note'>{{data.note | truncate(20, '...')}} <br> 
                                  <span class="text-info">{{data.noteLastEditedDate ? moment(data.noteLastEditedDate).format('MM/DD/YYYY h:mm:ss a') : ''}}</span>
                                </td>
                                <td>{{data.pmp}}</td>
                                <td>{{data.export ? "YES" : "NO"}}</td>
                                <td>{{data.maturity}}</td>
                                <td>{{data.spread}}</td>
                                <td>{{data.contact}}</td>
                                <td>{{data.eod}}</td>
                                <td>{{data.primaryRepName}}</td>
                                <td>{{data.secondaryRepName}}</td>
                                
                                <td class="text-center">
                                  <a   @click="editAccount(data)" class="btn ibtn grn"><i class="fas fa-pencil-alt"></i></a>
                                  <a  data-toggle="tooltip" data-placement="left" title="Note history" @click="toggleNoteHistoryModal(data)" class="btn ibtn grn"><i class="fas fa-history"></i></a>
                                      
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <!-- Pagination-->
                        <b-pagination
                            class="mt-4"
                            :total-rows="totalRows"
                            v-model="currentPage"
                            :per-page="perPage"
                            @input="getAccountsList(currentPage)"
                        ></b-pagination>
                        <div class="total-records">
                            <span>Total Records : {{totalRows}}</span>
                        </div>
                        </div>
                    </div>
                    </div>
            </div>
        </div>
      <addAccount 
        v-if="accountModalOpen"
        v-bind:accountData="selectedAccount"
        @close="closeAccountEditModal()"
      ></addAccount>
      <UpdateMultipleAccounts 
        v-if="accountMultipleModalOpen"
        v-bind:accountMultipleData="seletedAccountsforEdit"
        @close="toggleMultipleAccountsEditModal()"
      ></UpdateMultipleAccounts>
      <NoteHistory
        v-if="noteHistoryModalOpen"
        v-bind:account="noteHistoryAccount"
        @close="toggleNoteHistoryModal()"
      ></NoteHistory>
    </div>      
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import addAccount from "./MoneyLineAccountsAddModal.vue"
import UpdateMultipleAccounts from "./AccountMultipleEditModal.vue"
import NoteHistory from "./NoteHistoryModal.vue"

export default {
  name: "imsmoneylineAccountComponent",
  components : {
      addAccount,
      UpdateMultipleAccounts,
      NoteHistory
  },
  data() {
    return {
        accessToken:null,
        loading : false,
        currentPage: 1,
        perPage: 10,
        searchValue : "",
        totalRows : 0,
        sortColumn: "",
        sortOrder: "ASC",
        accountListData : [],
        accountModalOpen : false,
        selectedAccount : {},
        exporting : false,
        accountMultipleModalOpen : false,
        seletedAccountsforEdit : [],
        noteHistoryModalOpen : false,
        noteHistoryAccount : "",
        showFilters : false,
        isMarginAcount : "",
        isExport : "",
        noteFilter : "",
        primaryRep : null,
        secondaryRep : null,
        representativeData : []


    };
  },
  methods: {
    clearFilter(){
      this.isMarginAcount = "";
      this.isExport = "";
      this.noteFilter = "";
      this.primaryRep = null;
      this.secondaryRep = null;
      this.getAccountsList();
    },
    toggleNoteHistoryModal(data){
      if(data)
      this.noteHistoryAccount = data;
      this.noteHistoryModalOpen = !this.noteHistoryModalOpen;
    },
    updateAccounts(){
      let selectedAccounts = [];
      this.accountListData.forEach((data) => {
        if(data.isSelect) selectedAccounts.push(data)
      });
      if(selectedAccounts.length == 0) this.$alert("Please Select Any Account","","error");
      else{
        this.seletedAccountsforEdit = selectedAccounts;
        this.toggleMultipleAccountsEditModal()
        
      }

    },
    toggleMultipleAccountsEditModal(){
      this.accountMultipleModalOpen = !this.accountMultipleModalOpen;
      if(!this.accountMultipleModalOpen) this.getAccountsList();
    },
    editAccount(data){
      let account = {...data};
      if(account.pmp == "N/A"){
        account.pmp = ""
      }
      if(account.isMargin == "N/A"){
        account.isMargin = ""
      }
      this.selectedAccount = account;
      this.accountModalOpen = true
    },
    closeAccountEditModal(){
      this.accountModalOpen = false
      this.getAccountsList(); 
    },
    searchAccount(){
      this.getAccountsList(); 
    },
    clearSearch(){
      this.searchValue = "";
      this.getAccountsList(); 
    },
    sort(column){
      this.sortColumn = column;
      this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
      this.getAccountsList();
    },
    getAccountsList() {
      this.loading = true;
      // if (!currentPage) {
      //   currentPage = 1;
      // }
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlBidSide +
            "/account/list-all?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&isMargin="+
            this.isMarginAcount+
            "&export="+
            this.isExport+
            "&note="+
            encodeURIComponent(this.noteFilter)+
            "&primaryRepId="+
            (this.primaryRep ? this.primaryRep.id : "")+
            "&secondaryRepId="+
            (this.secondaryRep ? this.secondaryRep.id : ""),
            auth

        )
        .then(result => {
           this.totalRows = result.data.pageInfo.totalElements;
           result.data.content.forEach(element => {
            if(element.isMargin === null){
               element.isMargin = "N/A"
            }else{
              element.isMargin ? element.isMargin = "YES" : element.isMargin = "NO"
            }
            if(element.pmp === null){
               element.pmp = "N/A"
            }else{
              element.pmp ? element.pmp = "YES" : element.pmp = "NO"
            }
            if(element.contact === null){
               element.contact = "N/A"
            }else{
              element.contact ? element.contact = "YES" : element.contact = "NO"
            }
            if(element.eod === null){
               element.eod = "N/A"
            }else{
              element.eod ? element.eod = "YES" : element.eod = "NO"
            }
           });
           this.accountListData = result.data.content;
           this.loading = false;
        })
    },
    exportAccount(){
      this.exporting = true;
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/money-line/accounts-download",
            auth
        )
        .then(response => {
          this.exporting = false;
          if(response.data){
            window.open(response.data, "_blank");
          }

        })
        .catch(e => {
          console.log(e);
          this.exporting = false;
        });
    },
    getRepresentativeList() {
      const auth = {
          headers: {'org-token' : authService.getOrgToken() }
      };
      let url = "/money-line/representative-list";
      this.$http
          .get(
          config.baseUrlAutoBidder +
              url,
              auth
          )
          .then(result => {
          this.representativeData = result.data
          })
      }
  },
  mounted() {
    this.getRepresentativeList()
    this.getAccountsList();
  }
};
</script>